// extracted by mini-css-extract-plugin
module.exports = {"container":"cd01fbf7b5--container--yjJ7z","left_arrow":"cd01fbf7b5--left_arrow--C9h1Z","right_arrow":"cd01fbf7b5--right_arrow--fAaoE"};